import React, { Component } from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class TeamNameFilter extends Component {
    state = {
        teamLists: [],
        teamValue: '',
    };
    componentDidMount(){
        this._get_team();
    }
    resetTeamFilter() {
        this.setState({
            teamValue: [],
        });
    }
    _get_team(){
        const report_type = this.props.report_type || '';
        axios.get(config.get('API_URL')+'/filters/service_reports/get-teams/',{
            headers: {
                Authorization: `${localStorage.usertoken}`
            },
            params: {
                report_type: report_type
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                const teamLists = response.data.map(team => ({
                    value: team.teamid,
                    label: team.teamname
                }));
                this.setState({ teamLists, loading: false });
            }
        });
    }
    changeTeam(optionSelected) {
        let teamArray = [];

        if (optionSelected.length > 0) {
            optionSelected.map((item) => {
                teamArray.push(item.value);
            });
        } else {
            teamArray = '';
        }

        this.props.onSelectTeam(optionSelected, teamArray);

        this.setState({
            teamValue: optionSelected,
        });
    }

    render() {
        return (
            <ReactMultiSelectCheckboxes
                name="team"
                isMulti
                value={this.state.teamValue}
                styles={reactSelectStyles}
                className="report-listbox"
                isClearable={false}
                onChange={this.changeTeam.bind(this)}
                options={this.state.teamLists}
                placeholderButtonLabel="Select [Team]"
            />
        );
    }
}

export default TeamNameFilter;
